import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';

mapboxgl.accessToken = 'pk.eyJ1IjoibmFmZnRvIiwiYSI6ImNqYmVyd3Z1djF4OTYyd211c2Z4N3B0bWEifQ.VddAgog_VwojpDmmgNbzOg';
